import React from "react";
import TabNavigation from "components/ui/TabNavigation";

const ThankYouPage = () => {
  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: "var(--color-background)" }}
    >
      <TabNavigation />
      <div className="pt-[60px]" />
      <main className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-16">
        <div
          className="rounded-2xl p-8 md:p-10 text-center"
          style={{ backgroundColor: "var(--color-card)", border: "1px solid var(--color-border)" }}
        >
          <h1
            className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4"
            style={{ color: "var(--color-text-primary)" }}
          >
            Merci d&apos;avoir répondu au QCM
          </h1>
          <p
            className="text-sm md:text-base"
            style={{ color: "var(--color-muted-foreground)" }}
          >
            Vos réponses ont bien été enregistrées. Vous pouvez consulter le récapitulatif
            des résultats dans l&apos;onglet &laquo; Résultats &raquo;.
          </p>
        </div>
      </main>
    </div>
  );
};

export default ThankYouPage;

